<template>
    <v-app v-if="isLoading">
        <loading />
    </v-app>
    <v-container fluid v-else>
        <v-row v-if="about">
            <v-col cols="12" md="6">
                <v-card
                    flat
                    color="White"
                    rounded="xl"
                    class="border mt-4 mx-auto rounded-tr-0 EK-shadow IMTGray"
                    max-width="500"
                >
                    <v-card-title class="justify-content-center">
                        الوصف
                    </v-card-title>
                    <v-card-text class="text-start">
                        {{ about.description }}
                    </v-card-text>
                </v-card>
                <v-card v-if="about.allowed" flat
                        color="White"
                        rounded="xl"
                        class="border mt-4 mx-auto rounded-tr-0 EK-shadow IMTGray"
                        max-width="500">
                    <v-card-title class="justify-content-center">
                        عدد المشتركين
                    </v-card-title>
                    <v-card-text  class="text-start">
                        {{ about.shopsCount }} ({{about.realShopCount}} فعلي)
                    </v-card-text>
             
                </v-card>
                <v-card  v-if="about.allowed" flat
                        color="White"
                        rounded="xl"
                        class="border mt-4 mx-auto rounded-tr-0 EK-shadow IMTGray"
                        max-width="500">
                    <v-card-title class="justify-content-center">
                        عدد المستفيدين
                    </v-card-title>

                    <v-card-text class="text-start">
                        {{ about.usersCount }} ({{about.realUsersCount}} فعلي)
                    </v-card-text>
                 
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card flat
                        color="White"
                        rounded="xl"
                        class="border pl-4 mt-4 mx-auto rounded-tl-0 EK-shadow IMTGray text-right"
                        max-width="500">
                    <v-card-title class="justify-content-center">
                        معلومات التواصل
                    </v-card-title>
                    <v-card-text style="display: flex; align-items: center;">
                        <img src="/media/svg/about/Iconly-Bulk-Location.svg"
                             width="30px;" />
                        <p class="m-0 pr-1 titleAbout text-IMTOrange"
                           style="word-break: break-all;">
                            العنوان:
                        </p>
                        <p class="m-0 pr-3">{{ about.address }}</p>
                    </v-card-text>
                    <v-card-text style="display: flex; align-items: center;">
                        <img src="/media/svg/about/Iconly-Bulk-Call.svg"
                             width="30px;" />
                        <p class="m-0 pr-1 titleAbout text-IMTOrange">
                            رقم الموبايل:
                        </p>
                        <p class="m-0 pr-3">{{ about.mobileNumber }}</p>
                    </v-card-text>
                    <v-card-text style="display: flex; align-items: center;">
                        <img src="/media/svg/about/Iconly-Bulk-Calling.svg"
                             width="30px;" />
                        <p class="m-0 pr-1 titleAbout text-IMTOrange">
                            رقم الهاتف:
                        </p>
                        <p class="m-0 pr-3">{{ about.phoneNumber }}</p>
                    </v-card-text>
                    <v-card-text style="display: flex; align-items: center;">
                        <img src="/media/svg/about/email.svg" width="30px;" />
                        <p class="m-0 pr-1 titleAbout text-IMTOrange">
                            البريد الالكتروني:
                        </p>
                        <p class="m-0 pr-3"
                           style="word-break: break-all;"
                           dir="ltr">
                            {{ about.email }}
                        </p>
                    </v-card-text>
                    <v-card-text style="display: flex; align-items: center;">
                        <img src="/media/svg/about/facebook.svg"
                             width="30px;" />
                        <p class="m-0 pr-1 titleAbout text-IMTOrange">
                            فيسبوك:
                        </p>
                        <p class="m-0 pr-3"
                           style="word-break: break-all;"
                           dir="ltr">
                            {{ about.facebookLink }}
                        </p>
                    </v-card-text>
                    <v-card-text style="display: flex; align-items: center;">
                        <img src="/media/svg/about/instagram.svg"
                             width="30px;" />
                        <p class="m-0 pr-1 titleAbout text-IMTOrange">
                            انستاغرام:
                        </p>
                        <p class="m-0 pr-3"
                           style="word-break: break-all;"
                           dir="ltr">
                            {{ about.instagramLink }}
                        </p>
                    </v-card-text>
                    <v-card-text style="display: flex; align-items: center;">
                        <img src="/media/svg/about/telegram.svg"
                             width="30px;" />
                        <p class="m-0 pr-1 titleAbout text-IMTOrange">
                            تلغرام:
                        </p>
                        <p class="m-0 pr-3"
                           style="word-break: break-all;"
                           dir="ltr">
                            {{ about.telegramLink }}
                        </p>
                    </v-card-text>
                    <v-card-text style="display: flex; align-items: center;">
                        <img src="/media/svg/about/whatsapp-svgrepo-com.svg"
                             width="30px;" />
                        <p class="m-0 pr-1 titleAbout text-IMTOrange">
                            Whatsapp:
                        </p>
                        <p class="m-0 pr-3"
                           style="word-break: break-all;"
                           dir="ltr">
                            {{ about.whatsappLink }}
                        </p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        
        <v-row  v-else>
                    <v-col cols="12">
                <h2 class="text-center">لايوجد بيانات</h2>
            </v-col>
        </v-row>
        <v-row  class="justify-content-center my-5">

            <v-col cols="12">
                <div style="width:100%;  display:flex; justify-content:center">
                    <v-btn
                        @click="isShow()"
                        class="rounded-xl m-auto rounded-tr-0 px-10 py-5"
                        >تعديل</v-btn
                    >
                </div>
            </v-col>
        </v-row>
        <v-dialog v-model="show" width="1000px">
            <edit-dialog :about="about" @close="isShow()" />
        </v-dialog>
    </v-container>
</template>

<style>
.titleAbout {
    font-size: larger;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import loading from "@/components/loading";
import EditDialog from "./components/edit-dialog.vue";
export default {
    data: () => ({
        show: false
    }),
    methods: {
        ...mapActions(["setBreadcrumbs", "fetchAbout"]),
        isShow() {
            this.show = !this.show;
        }
    },
    computed: {
        ...mapGetters(["about", "isLoading"])
    },
    components: {
        loading,
        EditDialog
    },
    created() {
        this.fetchAbout();
        this.setBreadcrumbs([
            {
                text: "الإعدادت",
                disabled: false
            },
            {
                text: "حول",
                disabled: false
            }
        ]);
    }
};
</script>
